import { FC } from 'react';
import ModalPortalComp from 'app/react-components/modal-comp/modal-comp';
import styles from './care-now-programs-modal.module.scss';
import { sanitizeHtml } from 'wa-storybook/helpers/sanitize';
import classNames from 'classnames';
import CtaCard from './cta-card';
import Button from 'wa-storybook/components/general/button/button';
import openNew from 'assets/images/icons/ic_open_new.svg';
import { getZendeskLink } from 'state/global/actions';

type Props = {
  onClose: () => void;
  isOpen: boolean;
  onSoloCta: () => void;
  onCounsellorAssisted: () => void;
  isCareNowEnabled: boolean;
};

const CareNowProgramsModal: FC<Props> = ({
  onClose,
  isOpen,
  onSoloCta,
  onCounsellorAssisted,
  isCareNowEnabled,
}: Props) => {
  return (
    <ModalPortalComp
      animated
      isFullScreen={context.viewport.isMobile}
      isOpen={isOpen}
      onRequestClose={onClose}
      removeMaxWidth
      shouldCloseOnEsc
      shouldCloseOnOuterClick
      showCloseButton
    >
      <div
        data-testid='care-now-programs-modal'
        className={styles['container']}
      >
        <h1 className={styles['header']}>{polyglot.t('care_now.title')}</h1>

        <p className={styles.text}>{polyglot.t('care_now.modal.info')}</p>

        <div className={styles.cards}>
          {isCareNowEnabled && (
            <CtaCard
              title={polyglot.t('care_now.modal.solo.title')}
              info={polyglot.t('care_now.modal.solo.info')}
            >
              <Button
                text={polyglot.t('care_now.modal.solo.cta')}
                onClick={onSoloCta}
              />
            </CtaCard>
          )}

          <CtaCard
            title={polyglot.t('care_now.modal.assisted.title')}
            info={polyglot.t('care_now.modal.assisted.info')}
          >
            <Button
              text={polyglot.t('care_now.modal.assisted.cta')}
              icon={() => <img alt='' src={openNew} />}
              onClick={onCounsellorAssisted}
            />
          </CtaCard>
        </div>
        <p
          className={classNames(styles.text, styles.info)}
          dangerouslySetInnerHTML={{
            __html: sanitizeHtml(
              polyglot.t('care_now.modal.privacy', {
                url: getZendeskLink({ key: 'privacy_policy' }),
              }),
            ),
          }}
        />
      </div>
    </ModalPortalComp>
  );
};

export default CareNowProgramsModal;
